import React from 'react';
import { DateBoxProps } from './types';
import style from './style.module.scss';
import cx from 'classnames';

export const DateBox: React.FC<DateBoxProps> = ({ moment, variant }) => {
  return (
    <>
      <div className={cx(style.dateBox, variant === 'secondary' ? style.secondary : style.primary)}>
        <h4>
          <strong>{moment.day(1).format('MMM DD')}</strong>
        </h4>
      </div>
    </>
  );
};

export default DateBox;
